
export const projectsInitialState = {
    allProjects:[],
    error:null
};